import React from 'react'
import { useSelector } from 'react-redux';

const Function = () => {
  const {buyings}=useSelector((state)=>state.HomeReducer);
  return (
    <div className='container'>
   <div className=' d-flex justify-content-center flex-wrap mt-5 gap-3 ' >
    {buyings.map((buying,id)=>(
      <div className='col function' key={id}>
             <div className='function-icon '>
              {/* <i className="fa-solid fa-truck fa-flip-horizontal"></i> */}
              <img src={buying.image}/>
              </div>
              <h3>{buying.title}</h3>
              <p>{buying.description}</p>
        </div>
    ))}

    </div>
    </div>
 
  )
}

export default Function
